export default __webpack_public_path__ + "static/WORTHIT_GREEN-2d62305442634755a9be376c41a440fd.png";